/**
 * Old Twitter Layout (2026)
 *
 * Its single web-accessible-resource entry — layouts/*, images/*, fonts/*, libraries/*,
 * locale JSON and sandbox.html — is matched only to twitter.com and x.com. Nothing
 * scopes it to an arbitrary page, so those resources are genuinely unreachable elsewhere
 * and a negative from any other origin says nothing.
 *
 * From Twitter/X, though, the resources are static (no use_dynamic_url) at a fixed URL,
 * so a fetch of sandbox.html is conclusive.
 *
 * Manifest verified against version 1.9.7.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jgejdcdoeeabklepnkdbglgccjpdgpmf';

export const oldTwitterLayout: ExtensionDefinition = {
  id: ID,
  name: 'Old Twitter Layout (2026)',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 90_000,
  requiredOrigin: 'https://www.twitter.com',
  notes:
    'WAR scoped to twitter.com and x.com, so only those sites can detect it. The ' +
    'resources are static, so from Twitter a single fetch is conclusive.',
  signals: [
    {
      id: 'war-sandbox-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch sandbox.html — a fixed entry-point page, static and scoped to Twitter/X.',
      weight: 1,
      run: () => probeFetch(ID, 'sandbox.html'),
    },
    {
      id: 'war-home-style-css',
      kind: 'web-accessible-resource',
      description: 'Fetch layouts/home/style.css — the home-timeline stylesheet, a second scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'layouts/home/style.css'),
    },
    {
      id: 'war-logo-image',
      kind: 'web-accessible-resource',
      description: 'Fetch images/logo128.png — the extension logo, a third scoped path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'images/logo128.png'),
    },
  ],
};
